export default __webpack_public_path__ + "static/car3-8dfe36bb51cf3b461adb79e60aceaed6.glb";